<template>
	<component
    :is="component"
    :class="$style.root"
    v-on="$listeners"
  >
		<slot />
	</component>
</template>

<script>

import defaultRootComponent from '../defaultRootComponent'

export default {
  mixins: [ defaultRootComponent('div') ]
}

</script>

<style module>

.root {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1000; 
	@apply	
		bg-secondary-alpha;
} 

</style>
